<template>
  <div class="legal legal1">
    <div class="wrapper">
      <div class="legal__body">
        <div v-if="Page" class="legal">
          <button v-if="!xMobile" class="btn btn-back" @click.prevent="handleBack('/home')">
            <span>{{ trans.text.pages.back }}</span>
          </button>

          <div class="legal__headline">
            <h5>{{ getTitle(Page.data) }}</h5>
          </div> <!-- .legal__headline -->

          <div class="legal__content" v-html="getContent(Page.data)">
          </div> <!-- .legal__content -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  props: ['slug', 'lang', 'trans'],
  name: "LegalComponent",
  data() {
    return {
      fromRoute: null,
      xMobile: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from;
    })
  },
  computed: {
    ...mapGetters(['Page']),
  },
  methods: {
    ...mapActions(['getPageBySlug']),
    handleBack(fallback) {
      if (history.length === 1) {
        location.href = `/${this.lang}${fallback}`;
      } else {
        history.back()
      }
    },
    getTitle(title) {
      let prefix;
      let language = this.lang;
      prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }
      if (!!title && !!title[`${prefix}title`]) {
        return title[`${prefix}title`]
      }
      return '';
    },
    getContent(content) {
      let prefix;
      let language = this.lang;
      prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }
      if (!!content && !!content[`${prefix}content`]) {
        return content[`${prefix}content`]
      }
      return '';
    },
  },
  mounted() {
    let metas = document.getElementsByTagName('meta')
    let xMobileMeta
    for (let meta of metas) {
      if (meta.getAttribute('name') === 'x-mobile') {
        xMobileMeta = meta
        break;
      }
    }
    if (xMobileMeta) {
      this.xMobile = xMobileMeta.getAttribute('content') === '1'
    }
    this.getPageBySlug({
      path: this.$path,
      slug: this.slug,
    }).catch(error => {
      if (error.response && error.response.status === 404) {
        location.href = '/en/404'
      } else {
        console.dir(error)
      }
    })
  }
}
</script>
